<template>
  <div class="col mt-4">
    <div v-if="loaded">
    <cc-expandable-select
      v-for="option in variableOptions"
      :key="option.id"
      :title="option.title"
      :subtitle="option.subtitle"
    >
      <div slot="toggle-switch"> </div>
      <component 
        :is="option.component"
        :disabled="disabled"
        v-model="dashboardVariables[option.id]"
        class="border-top border-light"
        :data-testid="option.test_id"
      >
      </component>
    </cc-expandable-select>
  </div>
  </div>
</template>

<script>
import StationVariableOption from "./StationVariableOption"
import DaterangeVariableOption from "./DaterangeVariableOption"


export default {
  name: 'variables-aside',
  components: {
    StationVariableOption,
    DaterangeVariableOption
  },
  props: {
    saveTrigger: {
      type: Boolean,
    },
    variables: {
      type: Object
    }
  },
  data() {
    return {
      loaded : false,
      disabled : false,
      dashboardVariables : {
        stations : {
          enabled : false,
          filters : [],
          stations: []
        },
        daterange : {
          enabled : false,
          type : 'relative_date_range',
          options : {
            milliseconds : 1.728e+8, // 2 days
            unit : 'days',
            value : '2'
          }
        }
      }

    };
  },

  computed: {
    stationList(){
      return this.$store.state.stations;
    },
    variableOptions() {
      return [
        {
          id : 'stations',
          test_id : 'cmpStationVariable',
          title : this.$t('common:single_word.stations','Stations'),
          subtitle : "",
          component : StationVariableOption
        },
        {
          id : 'daterange',
          test_id : 'cmpDaterangeVariable',
          title : this.$t('common:single_word.date_range','Date Range'),
          subtitle : "",
          component : DaterangeVariableOption
        }
      ]
    },
  },

  methods: {
    init() {
      this.disabled = this.$s.can.not.access('dashboard..entity.update');
      if(this.variables){
        this.dashboardVariables.stations = this.variables.stations;
        this.dashboardVariables.daterange = this.variables.daterange;
      }
      this.loaded = true;
    },

    emitValue() {
      this.$emit('variables-updated', {
        ...this.dashboardVariables
      });
    },
  },

  watch: {
    saveTrigger(newValue, oldValue) {
      if (newValue === true) {
        this.emitValue();
        this.$emit('update:save-trigger', false);
      }
    },
    dashboard(newVal) {
      if (newVal !== null) {
        this.dashboardVariables.stations = newVal.stations;
        this.dashboardVariables.daterange = newVal.daterange;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>